import { useState } from "react"
import { useParams } from "react-router-dom"

import { Steps, Title } from "@/atoms"
import { EXTERNAL_ROUTES } from "@/const/routes.constants"
import { isSelfHosted } from "@/helpers/self-hosted.helper"
import { useTranslation } from "@/hooks/useTranslation"
import { ReadOutlined } from "@/icons"
import { InformationAlert } from "@/molecules/InformationAlert"
import { LinkButton } from "@/molecules/LinkButton"
import { DOCS_SLUG_BY_DEPLOY_TYPE } from "@/pages/DeploymentsPage/const"
import { DeployCommandValuesContext } from "@/pages/DeploymentsPage/hooks/useDeployCommandValues"

import styles from "./DeployTab.module.scss"

import type { DeployTabComponent } from "."

const DOCS_OVERVIEW_URL = `${EXTERNAL_ROUTES.API_DOCS}/deployments/deployments-overview`

export const DeployTab: DeployTabComponent = (props) => {
  const { t } = useTranslation()
  const { children, steps, message, title, hideReadMoreLink, docsSlug } = props
  const { type } = useParams()
  const value = useState({})

  const slug = docsSlug ?? (type ? DOCS_SLUG_BY_DEPLOY_TYPE[type] : undefined)
  const readInstructionsHref = slug
    ? `${DOCS_OVERVIEW_URL}/${slug}`
    : DOCS_OVERVIEW_URL

  return (
    <DeployCommandValuesContext.Provider value={value}>
      <Title className={styles.title} level={5}>
        {`${title || t("deployments.instructions")}:`}
      </Title>
      <Steps
        size="small"
        theme="dark"
        className={styles.steps}
        orientation="vertical"
        items={steps}
      />
      <div className={styles.main}>{children}</div>
      {!!message && (
        <InformationAlert className={styles.infoAlert} message={message} />
      )}
      {!hideReadMoreLink && !isSelfHosted() && (
        <LinkButton
          className={styles.readInstructionsLink}
          icon={<ReadOutlined />}
          size="small"
          type="link"
          href={readInstructionsHref}
          target="_blank"
        >
          {t(`general.readFullInstructions`)}
        </LinkButton>
      )}
    </DeployCommandValuesContext.Provider>
  )
}
